import React, { useRef } from "react";

const ButtonItem = ({
  k = -1,
  autoFocus,
  autocomplete = "on",
  inputStyle = {},
  inputClassName = "",
  type,
  disabled = false,
  id = null,
  value,
  change = () => {},
  placeholder = "",
  data,
  dk, //key of button element
  dataIndex = "id",
  dataLabel = "name",
  dataLabelIndex = false, //si le label est dans un objet ex : { label: { name: "Label"} }
  dataLabel2 = false,
  dataIcon = false,
  dataColor = false,
  btnInline = false,
  itemClassName = "",
  itemStyle = {},
  isActive,
  valueChange,
  btnClassName = null,
  name,
}) => {
  const btnRef = useRef(null);
  return (
    <button
      ref={btnRef}
      className={`
            btn  btn-sm 
            position-relative 
            align-items-center flex-fill justify-content-between mb-0 vivify flipInX 
            ${itemClassName} 
             btn-sm text-center me-0  me-1 justify-content-center flex-wrap  flex-row 
              ${
                isActive
                  ? dataColor
                    ? `btn-${data[dataColor]}`
                    : "btn-info text-white"
                  : "btn-default"
              }
            `}
      style={{
        ...itemStyle,
        animationDelay: `${dk * 30}ms`,
      }}
      disabled={disabled ? "disabled" : false}
      type="button"
      key={`${name} - ${data.id ? data.id : data._id ? data._id + dk : "abcd" + dk} `}
      onClick={(e) => {
        valueChange(e, data[dataIndex], data.isExclusive);
      }}
    >
      {dataIcon && (
        <div
          className={`d-flex align-items-center justify-content-center p-2 ${
            !btnInline ? "me-2" : ""
          }`}
        >
          <i
            className={"illustration fa fa-" + data[dataIcon] + ""}
            style={{
              background: "transparent",
              fontSize: 26,
              padding: 0,
              width: 26,
            }}
          />
        </div>
      )}
      <p className={`d-flex flex-column mb-0  flex-fill`}>
        {dataLabelIndex ? data[dataLabel][dataLabelIndex] : data[dataLabel]}

        {data.dataLabel2 && (
          <span className={`mt-1 `} style={{ fontSize: 11, lineHeight: "12px" }}>
            {data.dataLabel2}
          </span>
        )}
      </p>

      <i
        className={`check-icon fa fa-check ms-2 animated ${
          isActive ? "fadeInDown" : "fadeOutUp"
        } faster 
          position-absolute text-white bg-success shadow-sm 
                  `}
        style={{
          top: -6,
          right: -6,
          fontSize: 8,
          padding: "3px",
          borderRadius: "100%",
          zIndex: "9",
        }}
      />
    </button>
  );
};

export default ButtonItem;
